// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__h1mPh","options_box":"SearchBar_options_box__S0yhS"};